var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.can_show
    ? _c(
        "b-row",
        { staticClass: "mem_text position-relative" },
        [
          _c(
            "div",
            { staticClass: "edit_text", on: { click: _vm.edit_text } },
            [_c("fa", { attrs: { icon: _vm.faEdit } })],
            1
          ),
          _vm._v(" "),
          _vm.show_label
            ? _c(
                "b-col",
                { staticClass: "position-relative", attrs: { sm: "2" } },
                [_c("label", [_vm._v(_vm._s(_vm.label))])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "bd-callout bd-callout-info",
            attrs: { sm: _vm.show_label ? 10 : 12 },
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }